var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import FullScreenOverlay from '../fullScreenOverlay/FullScreenOverlay';
import DropDown from '../dropdown/components/DropDown';
import { findGroup } from '../dropdown/utils';
import { useReferenceFieldDrop } from './dragAndDropHook';
import Spinner from '../spinner/components/Spinner';
import SingleLineField from '../singleLineField/components/SingleLineField';
import AccurityIconButton from '../buttons/components/AccurityIconButton';
var REFERENCE_FIELD_ICON_WIDTH = 56;
var getValueAsSelectedItem = function (value, menuItems) {
    if (value && menuItems) {
        return menuItems.find(function (item) { return typeof item === 'string' ? item === value : item.name === value; });
    }
    return undefined;
};
var ReferenceField = function (props) {
    var elementRef = useRef(null);
    var _a = useState(false), isFocused = _a[0], setFocused = _a[1];
    var _b = useState(getValueAsSelectedItem(props.value, props.menuItems)), selectedItem = _b[0], setSelectedItem = _b[1];
    var selectedIcon = function (item) {
        if (item == null || typeof item === 'string') {
            return props.icon;
        }
        if (props.menuGroups) {
            var group = findGroup(props.menuGroups, item.objectType);
            if (group) {
                return group.icon;
            }
        }
        return props.icon;
    };
    var onSelect = function (item) {
        setFocused(false);
        setSelectedItem(item);
        props.onSelect(item);
    };
    var onChange = function (value) {
        if (!isFocused) {
            setFocused(true);
        }
        props.onChange(value);
    };
    var onFocus = function () {
        setFocused(true);
        props.onFocus && props.onFocus();
    };
    // Get width of DropDown and position to display it from, for both if it will open downwards or open upwards
    var getDropdownPosition = function () {
        if (!elementRef.current || !isFocused) {
            return undefined;
        }
        var fieldRect = elementRef.current.getBoundingClientRect();
        var iconOffset = props.icon ? REFERENCE_FIELD_ICON_WIDTH : 0;
        return {
            width: fieldRect.width - iconOffset,
            x: fieldRect.left + iconOffset,
            openDownwardsY: fieldRect.bottom - 10,
            openUpwardsY: fieldRect.top,
        };
    };
    var inverted = props.inverted, _c = props.showDefaultTooltip, showDefaultTooltip = _c === void 0 ? true : _c;
    var getInputContentRight = function () {
        if (props.menuItemIsLoading) {
            return (React.createElement(Spinner, { size: "sm" }));
        }
        if (props.value !== '' && isFocused && !props.hideRemoveButton) {
            return (React.createElement(AccurityIconButton, { onClick: function () { return onSelect(undefined); }, iconName: "mui:Close", size: "small", name: "clear-input" }));
        }
        return null;
    };
    var tooltip = props.tooltip;
    if (showDefaultTooltip && (props.value || props.description)) {
        tooltip = { value: props.value || '', description: props.description };
    }
    var dropdownPosition = getDropdownPosition();
    // Drag and Drop
    var _d = useReferenceFieldDrop(__assign(__assign({}, props), { onValidDrop: onSelect })), dropProps = _d[0], dropRef = _d[1];
    var dropTargetClassName = dropProps.validDropTarget && dropProps.hovered ? 'validDragDropTargetHovered'
        : dropProps.validDropTarget ? 'validDragDropTarget'
            : undefined;
    var dropTargetArea = dropProps.validDropTarget
        ? React.createElement("div", { className: "referenceFieldDropArea", ref: dropRef })
        : null;
    // End Drag and Drop
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames('ReferenceField', { inverted: inverted }), ref: elementRef },
            isFocused ?
                React.createElement(FullScreenOverlay, { onClick: function () {
                        props.onOutsideClick && props.onOutsideClick();
                        setFocused(false);
                    } }) : null,
            React.createElement("div", { className: classNames('ReferenceField__content', { withIcon: !!props.icon }, { inverted: inverted }) },
                dropTargetArea,
                React.createElement(SingleLineField, { name: props.name, label: props.label, value: props.value, shouldFocus: props.shouldFocus, tooltip: tooltip, onChange: onChange, onFocus: onFocus, onBlur: props.onBlur, errorMessage: props.errorMessage, disabled: props.disabled, type: "text", icon: selectedIcon(selectedItem), iconAction: props.iconAction ? function () { return props.iconAction && props.icon && props.iconAction(props.icon); } : undefined, dropTargetClassName: dropTargetClassName, inputContentRight: getInputContentRight() || undefined, inverted: inverted, style: props.style, coloring: props.coloring, inherited: props.inherited }),
                isFocused ? (React.createElement(DropDown, { name: props.name, htmlItemName: props.htmlItemName, fixedPosition: dropdownPosition, itemHeight: props.menuItemHeight, items: props.menuItems, groups: props.menuGroups, emptyItemsLabel: props.emptyMenuItemsLabel, itemRenderer: props.menuItemRenderer, displayToolTips: showDefaultTooltip, isLoading: props.menuItemIsLoading || false, onSelect: onSelect, inverted: inverted })) : null))));
};
export default ReferenceField;
//# sourceMappingURL=ReferenceField.js.map